import React, { useEffect, useContext, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { DEFAULT_BOX_SHADOW, PRIMARY_BACKGROUND } from "App/constants/theme";

import { Paper } from "@material-ui/core";
import { Title } from "App/Component/ui";
import { FormReq, RenderListReq } from "./ui";

import { FormContext, FormProvider } from "./context/FormContext";
import { getReqListById } from "./helpers";
import { WMS_FA_PENGAJUAN } from "App/constants";
import { isNull } from "App/utils/helpers";
// import { isNull } from "App/utils/helpers";

const useStyles = makeStyles({
  root: {
    width: "auto",
  },
  paper: {
    width: "100%",
    margin: "0",
    padding: "1rem 1.5rem",
    backgroundColor: PRIMARY_BACKGROUND,
    boxShadow: DEFAULT_BOX_SHADOW,
  },
  table: {
    width: "100%",
    margin: "0 auto",
    overflow: "auto",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  textRed: {
    color: "red",
  },
  border: {
    paddingTop: "10px",
    borderBottom: "1.5px dashed #333333",
  },
});

export default function PengajuanFixedAsset(props) {
  const classes = useStyles();
  const { data, menu } = props;
  return (
    <FormProvider data={data} menu={menu}>
      <div className={classes.root}>
        <Title title={"Input Pengajuan Fix Asset"} />
        <Paper className={classes.paper}>
          <FormReq data={data} />
          <div className='mt-2'></div>
          <RenderContent
            classes={classes}
            data={menu === WMS_FA_PENGAJUAN ? data : null}
          />
        </Paper>
      </div>
    </FormProvider>
  );
}

const RenderContent = ({ classes, data }) => {
  const namaInputRef = useRef(null);
  const { setListREQ, setFilePDF, setFilePDFFile, setValidasi } =
    useContext(FormContext);

  useEffect(() => {
    setNewDataReqList(data?.idreq);
  }, [data]); // eslint-disable-line react-hooks/exhaustive-deps

  const setNewDataReqList = async (idreq) => {
    await getListReq(idreq);
  };

  const getListReq = async (idreq) => {
    if (!isNull(idreq)) {
      const res = await getReqListById(idreq);
      if (res.state) {
        setValidasi(res.validasi);
        setListREQ(res.data.detail);
        setFilePDF(res.data.tor_file);
        setFilePDFFile(res.data.data_file);
      } else {
        setListREQ([]);
        setFilePDF([]);
        setFilePDFFile([]);
      }
    }
  };

  return (
    <>
      <RenderListReq
        classes={classes}
        setNewDataReqList={setNewDataReqList}
        namaInputRef={namaInputRef}
      />
    </>
  );
};
